import { render, staticRenderFns } from "./paginator.vue?vue&type=template&id=aac8ef9a&"
import script from "./paginator.vue?vue&type=script&lang=ts&"
export * from "./paginator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aac8ef9a')) {
      api.createRecord('aac8ef9a', component.options)
    } else {
      api.reload('aac8ef9a', component.options)
    }
    module.hot.accept("./paginator.vue?vue&type=template&id=aac8ef9a&", function () {
      api.rerender('aac8ef9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paginator/paginator.vue"
export default component.exports